import React from "react";
import MatchHistory from "../MatchHistory/MatchHistory";

import "./history.scss";

export default function History({
  matches,
  championsList,
  game,
  userData,
  summoners,
  queueId,
}) {
  return (
    <div className="history">
      <div className="history__left">
        {/* <div className="history__left--top">
          <div className="headers">
            <div className="header active">Ranked Solo</div>
            <div className="header">Ranked Flex</div>
          </div>
          <Champ />
        </div> */}

        {/* <div className="history__left--bottom">
          <div className="title">Ranked Winrate For Past 7 Days</div>
          <WinStatus />
        </div> */}
      </div>

      <div className="history__right">
        {matches.length > 0 ? (
          matches.map(match => (
            <MatchHistory
              key={match.gameId}
              championID={match.champion}
              championsList={championsList}
              game={game}
              match={match}
              queueId={queueId}
              summoners={summoners}
              userData={userData}
            />
          ))
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
}
